/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountDelete($vendorAccountId: ID!) {
    VendorAccountDelete(vendorAccountId: $vendorAccountId) {
        message
        status
    }
} 
`

